/**
 * @flow
 * @relayHash ce36d4234a1e2cce82ff06d08ef18a1a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DashboardViewOld_root$ref = any;
export type USER_LANGUAGE = "de" | "en" | "fr" | "it" | "%future added value";
export type DashboardQueryVariables = {||};
export type DashboardQueryResponse = {|
  +viewer: ?{|
    +language: ?USER_LANGUAGE,
    +firstName: ?string,
    +lastName: ?string,
    +fullName: ?string,
  |},
  +$fragmentRefs: DashboardViewOld_root$ref,
|};
export type DashboardQuery = {|
  variables: DashboardQueryVariables,
  response: DashboardQueryResponse,
|};
*/


/*
query DashboardQuery {
  ...DashboardViewOld_root
  viewer {
    language
    firstName
    lastName
    fullName
    id
  }
}

fragment DashboardViewOld_root on Query {
  viewer {
    id
    lastName
    fullName
    isActive
    isAdmin
    isSuperAdmin
    isLoggedInAs
    isBroker
    isSeller
    isInvestor
  }
  ...DashboardUsers_root
  ...DashboardUsersActive_root
  ...DashboardOrganisations_root
  ...DashboardDeals_root
  ...DashboardNotes_root
  ...DashboardUsersDeleted_root
  ...UserTasks_root
}

fragment DashboardUsers_root on Query {
  users(first: 5, sortBy: "updatedAt", sortDirection: DESC) {
    edges {
      node {
        id
        fullName
        jobTitle
        organisation {
          name
          id
        }
        updatedAt
        ...UserAvatar_user
      }
    }
  }
}

fragment DashboardUsersActive_root on Query {
  activeUsers: users(first: 5, sortBy: "lastSeen", sortDirection: DESC) {
    edges {
      node {
        id
        fullName
        jobTitle
        organisation {
          name
          id
        }
        lastSeen
        updatedAt
        ...UserAvatar_user
      }
    }
  }
}

fragment DashboardOrganisations_root on Query {
  organisations(first: 5, sortBy: "updatedAt", sortDirection: DESC) {
    edges {
      node {
        id
        name
        updatedAt
        ...UserAvatar_organisation
      }
    }
  }
}

fragment DashboardDeals_root on Query {
  deals(first: 5, sortBy: "updatedAt", sortDirection: DESC) {
    edges {
      node {
        id
        name
        title
        status {
          label
          id
        }
        dealType {
          label
          id
        }
        image {
          url
          id
        }
        updatedAt
      }
    }
  }
}

fragment DashboardNotes_root on Query {
  notes: activities(first: 5, filters: {type: NOTE}) {
    edges {
      node {
        id
        note
        updatedAt
        createdAt
        type
        creator {
          fullName
          id
        }
        parent {
          id
          __typename
          ... on Lead {
            deal {
              id
              name
            }
            organisation {
              id
              name
            }
          }
        }
      }
    }
  }
}

fragment DashboardUsersDeleted_root on Query {
  deletedUsersActivities: activities(first: 5, sortBy: "createdAt", sortDirection: DESC, filters: {type: USER_DELETED}) {
    edges {
      node {
        id
        createdAt
        userData {
          id
          fullName
          jobTitle
          organisation {
            name
            id
          }
          ...UserAvatar_user
        }
      }
    }
  }
}

fragment UserTasks_root on Query {
  ...ActivityCard_root
  viewer {
    id
    organisation {
      id
      tasks(sortDirection: DESC, first: 100000) {
        edges {
          node {
            id
            isDone
            assignee {
              id
            }
            parent {
              __typename
              id
            }
            ...ActivityCard_activity
            __typename
          }
          cursor
        }
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
        totalCount
      }
      users {
        id
        fullName
      }
    }
  }
}

fragment ActivityCard_root on Query {
  viewer {
    id
  }
  ...ActivityForm_root
}

fragment ActivityCard_activity on Activity {
  ...ActivityForm_activity
  id
  isDone
  isSuccess
  updatedAt
  createdAt
  dueAt
  doneAt
  note
  subject
  deal {
    id
  }
  leadData {
    id
    isInterested
    refusalReasonText
    refusalReasons {
      id
      label
    }
  }
  parent {
    __typename
    id
    ... on Lead {
      deal {
        id
        name
      }
      organisation {
        id
        name
      }
    }
    ... on Deal {
      name
      image {
        url
        id
      }
    }
    ... on User {
      fullName
    }
    ... on Organisation {
      name
    }
  }
  creator {
    id
    fullName
  }
  type
  user {
    id
    fullName
  }
  assignee {
    id
    fullName
  }
  email {
    id
  }
  file {
    id
    filename
    size
    mimetype
    url
  }
}

fragment ActivityForm_activity on Activity {
  id
  note
  subject
  assignee {
    id
  }
  dueAt
  isDone
  type
}

fragment ActivityForm_root on Query {
  viewer {
    organisation {
      users {
        id
        fullName
      }
      id
    }
    id
  }
}

fragment UserAvatar_user on User {
  id
  firstName
  lastName
  fullName
  primaryImage {
    url
    id
  }
}

fragment UserAvatar_organisation on Organisation {
  id
  name
  primaryImage {
    url
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "language",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "kind": "Literal",
  "name": "sortDirection",
  "value": "DESC"
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  },
  (v6/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v10 = [
  (v4/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "kind": "InlineFragment",
  "type": "Lead",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "deal",
      "storageKey": null,
      "args": null,
      "concreteType": "Deal",
      "plural": false,
      "selections": (v10/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "organisation",
      "storageKey": null,
      "args": null,
      "concreteType": "Organisation",
      "plural": false,
      "selections": (v10/*: any*/)
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v13 = [
  (v12/*: any*/),
  (v4/*: any*/)
],
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "image",
  "storageKey": null,
  "args": null,
  "concreteType": "Image",
  "plural": false,
  "selections": (v13/*: any*/)
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "note",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v19 = [
  (v4/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v22 = [
  (v21/*: any*/),
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "updatedAt"
  },
  (v6/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jobTitle",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "organisation",
  "storageKey": null,
  "args": null,
  "concreteType": "Organisation",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v4/*: any*/)
  ]
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "primaryImage",
  "storageKey": null,
  "args": null,
  "concreteType": "Image",
  "plural": false,
  "selections": (v13/*: any*/)
},
v26 = [
  (v20/*: any*/),
  (v4/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DashboardQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "DashboardViewOld_root",
        "args": null
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DashboardQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isActive",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isAdmin",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isSuperAdmin",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isLoggedInAs",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isBroker",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isSeller",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isInvestor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "organisation",
            "storageKey": null,
            "args": null,
            "concreteType": "Organisation",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "users",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": true,
                "selections": (v5/*: any*/)
              },
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tasks",
                "storageKey": "tasks(first:100000,sortDirection:\"DESC\")",
                "args": (v7/*: any*/),
                "concreteType": "ActivityConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ActivityEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Activity",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isDone",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "assignee",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": (v5/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "parent",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v8/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "Deal",
                                "selections": [
                                  (v9/*: any*/),
                                  (v14/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "User",
                                "selections": [
                                  (v3/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "Organisation",
                                "selections": [
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subject",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dueAt",
                            "args": null,
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isSuccess",
                            "args": null,
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "doneAt",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "deal",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Deal",
                            "plural": false,
                            "selections": (v19/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "leadData",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Lead",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isInterested",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "refusalReasonText",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "refusalReasons",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "NotInterestedReason",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "creator",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": (v5/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": (v5/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "email",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Email",
                            "plural": false,
                            "selections": (v19/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "file",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "File",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "filename",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "size",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "mimetype",
                                "args": null,
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ]
                          },
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "startCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalCount",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "tasks",
                "args": (v7/*: any*/),
                "handle": "connection",
                "key": "UserTasks_tasks",
                "filters": [
                  "sortDirection"
                ]
              }
            ]
          },
          (v0/*: any*/),
          (v1/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "users",
        "storageKey": "users(first:5,sortBy:\"updatedAt\",sortDirection:\"DESC\")",
        "args": (v22/*: any*/),
        "concreteType": "UserConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v17/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v25/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "activeUsers",
        "name": "users",
        "storageKey": "users(first:5,sortBy:\"lastSeen\",sortDirection:\"DESC\")",
        "args": [
          (v21/*: any*/),
          {
            "kind": "Literal",
            "name": "sortBy",
            "value": "lastSeen"
          },
          (v6/*: any*/)
        ],
        "concreteType": "UserConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastSeen",
                    "args": null,
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v25/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "organisations",
        "storageKey": "organisations(first:5,sortBy:\"updatedAt\",sortDirection:\"DESC\")",
        "args": (v22/*: any*/),
        "concreteType": "OrganisationConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "OrganisationEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Organisation",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v25/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deals",
        "storageKey": "deals(first:5,sortBy:\"updatedAt\",sortDirection:\"DESC\")",
        "args": (v22/*: any*/),
        "concreteType": "DealConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "DealEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Deal",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "status",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DealStatus",
                    "plural": false,
                    "selections": (v26/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "dealType",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DealType",
                    "plural": false,
                    "selections": (v26/*: any*/)
                  },
                  (v14/*: any*/),
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "notes",
        "name": "activities",
        "storageKey": "activities(filters:{\"type\":\"NOTE\"},first:5)",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "type": "NOTE"
            }
          },
          (v21/*: any*/)
        ],
        "concreteType": "ActivityConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ActivityEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Activity",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "parent",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "deletedUsersActivities",
        "name": "activities",
        "storageKey": "activities(filters:{\"type\":\"USER_DELETED\"},first:5,sortBy:\"createdAt\",sortDirection:\"DESC\")",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "type": "USER_DELETED"
            }
          },
          (v21/*: any*/),
          {
            "kind": "Literal",
            "name": "sortBy",
            "value": "createdAt"
          },
          (v6/*: any*/)
        ],
        "concreteType": "ActivityConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ActivityEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Activity",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userData",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v25/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "DashboardQuery",
    "id": null,
    "text": "query DashboardQuery {\n  ...DashboardViewOld_root\n  viewer {\n    language\n    firstName\n    lastName\n    fullName\n    id\n  }\n}\n\nfragment DashboardViewOld_root on Query {\n  viewer {\n    id\n    lastName\n    fullName\n    isActive\n    isAdmin\n    isSuperAdmin\n    isLoggedInAs\n    isBroker\n    isSeller\n    isInvestor\n  }\n  ...DashboardUsers_root\n  ...DashboardUsersActive_root\n  ...DashboardOrganisations_root\n  ...DashboardDeals_root\n  ...DashboardNotes_root\n  ...DashboardUsersDeleted_root\n  ...UserTasks_root\n}\n\nfragment DashboardUsers_root on Query {\n  users(first: 5, sortBy: \"updatedAt\", sortDirection: DESC) {\n    edges {\n      node {\n        id\n        fullName\n        jobTitle\n        organisation {\n          name\n          id\n        }\n        updatedAt\n        ...UserAvatar_user\n      }\n    }\n  }\n}\n\nfragment DashboardUsersActive_root on Query {\n  activeUsers: users(first: 5, sortBy: \"lastSeen\", sortDirection: DESC) {\n    edges {\n      node {\n        id\n        fullName\n        jobTitle\n        organisation {\n          name\n          id\n        }\n        lastSeen\n        updatedAt\n        ...UserAvatar_user\n      }\n    }\n  }\n}\n\nfragment DashboardOrganisations_root on Query {\n  organisations(first: 5, sortBy: \"updatedAt\", sortDirection: DESC) {\n    edges {\n      node {\n        id\n        name\n        updatedAt\n        ...UserAvatar_organisation\n      }\n    }\n  }\n}\n\nfragment DashboardDeals_root on Query {\n  deals(first: 5, sortBy: \"updatedAt\", sortDirection: DESC) {\n    edges {\n      node {\n        id\n        name\n        title\n        status {\n          label\n          id\n        }\n        dealType {\n          label\n          id\n        }\n        image {\n          url\n          id\n        }\n        updatedAt\n      }\n    }\n  }\n}\n\nfragment DashboardNotes_root on Query {\n  notes: activities(first: 5, filters: {type: NOTE}) {\n    edges {\n      node {\n        id\n        note\n        updatedAt\n        createdAt\n        type\n        creator {\n          fullName\n          id\n        }\n        parent {\n          id\n          __typename\n          ... on Lead {\n            deal {\n              id\n              name\n            }\n            organisation {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DashboardUsersDeleted_root on Query {\n  deletedUsersActivities: activities(first: 5, sortBy: \"createdAt\", sortDirection: DESC, filters: {type: USER_DELETED}) {\n    edges {\n      node {\n        id\n        createdAt\n        userData {\n          id\n          fullName\n          jobTitle\n          organisation {\n            name\n            id\n          }\n          ...UserAvatar_user\n        }\n      }\n    }\n  }\n}\n\nfragment UserTasks_root on Query {\n  ...ActivityCard_root\n  viewer {\n    id\n    organisation {\n      id\n      tasks(sortDirection: DESC, first: 100000) {\n        edges {\n          node {\n            id\n            isDone\n            assignee {\n              id\n            }\n            parent {\n              __typename\n              id\n            }\n            ...ActivityCard_activity\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          hasNextPage\n          startCursor\n          endCursor\n        }\n        totalCount\n      }\n      users {\n        id\n        fullName\n      }\n    }\n  }\n}\n\nfragment ActivityCard_root on Query {\n  viewer {\n    id\n  }\n  ...ActivityForm_root\n}\n\nfragment ActivityCard_activity on Activity {\n  ...ActivityForm_activity\n  id\n  isDone\n  isSuccess\n  updatedAt\n  createdAt\n  dueAt\n  doneAt\n  note\n  subject\n  deal {\n    id\n  }\n  leadData {\n    id\n    isInterested\n    refusalReasonText\n    refusalReasons {\n      id\n      label\n    }\n  }\n  parent {\n    __typename\n    id\n    ... on Lead {\n      deal {\n        id\n        name\n      }\n      organisation {\n        id\n        name\n      }\n    }\n    ... on Deal {\n      name\n      image {\n        url\n        id\n      }\n    }\n    ... on User {\n      fullName\n    }\n    ... on Organisation {\n      name\n    }\n  }\n  creator {\n    id\n    fullName\n  }\n  type\n  user {\n    id\n    fullName\n  }\n  assignee {\n    id\n    fullName\n  }\n  email {\n    id\n  }\n  file {\n    id\n    filename\n    size\n    mimetype\n    url\n  }\n}\n\nfragment ActivityForm_activity on Activity {\n  id\n  note\n  subject\n  assignee {\n    id\n  }\n  dueAt\n  isDone\n  type\n}\n\nfragment ActivityForm_root on Query {\n  viewer {\n    organisation {\n      users {\n        id\n        fullName\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment UserAvatar_user on User {\n  id\n  firstName\n  lastName\n  fullName\n  primaryImage {\n    url\n    id\n  }\n}\n\nfragment UserAvatar_organisation on Organisation {\n  id\n  name\n  primaryImage {\n    url\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bfa47628a577ce81b1e955a1930b9d4d';
module.exports = node;
